import { ArrowTopRightOnSquareIcon, ArrowUturnLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

const AppFraudDisclaimer: React.FC = () => {
  const linkItems = [
    { text: "Why?", icon: ChevronRightIcon, target: "why" },
    { text: "What this means?", icon: ChevronRightIcon, target: "What-this-means" },
  ];

  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <h1 className="text-4xl font-extrabold text-gray-900">App Fraud Disclaimer</h1>
        <p className="mt-4 text-lg text-gray-700">Dear Customer,  </p>
      </header>

      {/* Main Content Section */}
      <section className="w-full px-5 mt-8 p-6">
        <p className="text-gray-800">
          We would like to inform you that the Authorised Push Payment (APP) Fraud Reimbursement rules, that apply to bank and payment service providers for relevant UK consumer accounts, do not apply to the accounts provided by Orenda Financial
          Services Limited.
        </p>
      </section>

      {/* Link Section */}
      <div className="w-full mt-8 bg-gray-100 rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {linkItems.map((item, index) => {
            const IconComponent = item.icon; // Get the icon component dynamically
            return (
              <a
                key={index}
                href={`#${item.target}`} // Anchor link to the section
                className="flex items-center justify-between bg-white p-4 rounded-lg shadow-md hover:bg-gray-50 transition"
              >
                <span className="text-gray-900 font-medium">{item.text}</span>
                <IconComponent className="h-6 w-6" /> {/* Render the icon dynamically */}
              </a>
            );
          })}
        </div>
      </div>

      <section id="why" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">Why?</h3>
        <p className="text-gray-800 mb-4">
          Our accounts are issued by a Gibraltar Financial Services Commission (GFSC)-licensed institution (Transact Payments Limited). This is important as the APP Fraud Reimbursement rules apply to relevant UK accounts and our accounts are issued
          by an institution domiciled and registered in Gibraltar, and are therefore out of scope of the reimbursement rules.
        </p>
      </section>
      <section id="What-this-means" className="w-full px-5 my-8 scroll-mt-20">
        <h4 className="text-xl font-semibold mt-6 mb-2">What this means?</h4>
        <p className="text-gray-800 mb-2">This means that if you are a victim of APP fraud (where a payment is made to a fraudster and authorised by you), you will not be entitled to reimbursement under the conditions set out in the rules.</p>
        <p className="text-gray-800 mb-2">Nevertheless, if you fall victim to APP Fraud, we will make every effort to recover your funds, provided you notify us immediately if you suspect or become aware of any fraudulent activity.</p>
        <p className="text-gray-800 mb-2">For more information on how to prevent APP Fraud from happening, please visit our FAQs</p>
      </section>
    </div>
  );
};

export default AppFraudDisclaimer;
